import {GetOrderLoyaltyInfoQuery} from '@data/__generated__/types.royalty'
import {gql, useApolloQuery} from 'apollo-hooks'

export function useOrderLoyaltyInfo(websiteId: string) {
  const data = useApolloQuery<GetOrderLoyaltyInfoQuery>({
    clientName: 'royalty',
    query: gql`
      query getOrderLoyaltyInfo($websiteId: String) {
        myLoyaltyCardAtWebsite(websiteId: $websiteId) {
          websiteId
          coinsName
          clientName
          countryCode
          backgroundColor
          secondaryColor
          textColor
          balance
          stripImageURL
          iconURL
          logoURL
          downloadURL
          downloadAppleURL
          downloadGoogleURL
          websiteName
          websiteURL
        }
      }
    `,
    variables: {websiteId},
    omit: !websiteId
  })

  return data?.myLoyaltyCardAtWebsite
}
